import { render, staticRenderFns } from "./UserProfileBlock.vue?vue&type=template&id=a28dd2ac"
import script from "./UserProfileBlock.vue?vue&type=script&lang=js"
export * from "./UserProfileBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports